import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';

type GetThemeValue = (theme: any, key?: string | number, fallback?: string) => any;

type GetTheme = (path?: string | number, fallback?: string) => ({ theme }: { theme: any }) => any;

type Default = { __default: string | number };
/**
 * Allows for nested scales with shorthand values
 * @example
 * {
 *   colors: {
 *     primary: { __default: '#00f', light: '#33f' }
 *   }
 * }
 * css({ color: 'primary' }); // { color: '#00f' }
 * css({ color: 'primary.light' }) // { color: '#33f' }
 */
export const THEME_DEFAULT_KEY = '__default';

export const hasDefault = (x: unknown): x is Default => typeof x === 'object' && x !== null && THEME_DEFAULT_KEY in x;

export const getThemeValue: GetThemeValue = (theme, key, fallback) => {
  if (isUndefined(key)) return fallback;
  const currentThemeKeys = key && isString(key) ? key.split('.') : [key];

  for (let p = 0; p < currentThemeKeys.length; p++) {
    theme = theme && !isString(theme) ? theme[currentThemeKeys[p]] : undefined;
  }

  if (theme === undefined) return fallback;

  return hasDefault(theme) ? theme[THEME_DEFAULT_KEY] : theme;
};

export const getTheme: GetTheme =
  (path, fallback = undefined) =>
  ({ theme }) =>
    getThemeValue(theme, path, fallback);

export default getTheme;
